import {Component, OnInit} from 'angular2/core';
import {BootstrapPaginationComponent} from "../../common/pagination/bootstrap_pagination.component";
import {VoucherService} from "../voucher.service";
import {PaginationService, PaginatePipe} from "ng2-pagination";
import {TranslatePipe, TranslateService} from "ng2-translate";
import {Router, RouteParams} from "angular2/router";
import {AlertService} from "../../common/alerts/alert.service";
import {Voucher} from "../../../models/voucher.model";
import {Campaign} from "../../../models/campaign.model";
import {CampaignService} from "../../campaigns/campaign.service";

@Component({
    templateUrl: './app/components/vouchers/index/list.html',
    directives: [BootstrapPaginationComponent],
    providers: [VoucherService, PaginationService, CampaignService],
    pipes: [TranslatePipe, PaginatePipe]
})

export class IndexVouchersComponent implements OnInit {
    page:number;
    perPage:number;
    total:number;
    searchQuery:string;
    vouchers:Voucher[];
    errorMessage:string;
    campaign:Campaign;

    constructor(private _voucherService:VoucherService, private _alert_service:AlertService, private _router:Router,
                private _translateService:TranslateService, private _params:RouteParams, private _campaignService:CampaignService) {
        this.page = 1;
        this.perPage = 25;
        this.campaign = new Campaign({});
        this.searchQuery = "";
    }

    ngOnInit() {
        this._voucherService.count(this._params.get("campaignId"), this.searchQuery).subscribe(count => this.total = count);
        this._campaignService.getCampaign(this._params.get("campaignId")).subscribe(campaign => this.campaign = campaign);
        this.getPage(this.page);
    }

    getPage(page:number) {
        this._voucherService.getVouchers(this._params.get("campaignId"), page, this.perPage, this.searchQuery).subscribe(
            vouchers => {
                this.vouchers = vouchers;
                this.page = page;
            },
            error => this.errorMessage = <any>error
        );
    }

    destroyVoucher(code:string) {
        let result = confirm(this._translateService.instant('vouchers.delete.confirm'));
        if (result) {
            this._voucherService.destroyVoucher(code).subscribe(a => {
                    this._router.navigate(['Vouchers', {"campaignId": this.campaign.id}]);
                    this._alert_service.pushAlert({
                        type: "success",
                        msg: this._translateService.instant("vouchers.delete.success"),
                        closeable: true
                    });
                    this.getPage(1);
                },
                error => this._alert_service.pushAlert({
                    type: "danger",
                    msg: this._translateService.instant(error),
                    closeable: true
                })
            );
        }
    }

    onChangeSearchQuery($event) {
        this._voucherService.count(this._params.get("campaignId"), this.searchQuery).subscribe(count => this.total = count);
        this.page = 1;
        this.getPage(this.page);
    }

}